/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { backdropStyle, panelStyle } from './Drawer.styles';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** 패널 너비(px). 기본 420. */
  width?: number;
  /** 접근성 라벨. */
  label?: string;
}

/**
 * 오른쪽에서 슬라이드로 나오는 오버레이 패널.
 * 백드롭 클릭·Esc로 닫힘. 행 상세 등 본문 위에 덮어 씌우는 컨텍스트 뷰에 활용.
 */
export function Drawer({ open, onClose, children, width = 420, label = '상세' }: DrawerProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div css={backdropStyle} onClick={onClose}>
      <aside
        css={panelStyle(width)}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </aside>
    </div>
  );
}
